import React, {useRef, useState, useEffect, useContext} from 'react';
import {useSelector, shallowEqual} from 'react-redux';
import {Chatbot} from '../../states/actions';
import {User} from '../../states/actions';
import {PreviewComponent, NodeComponent, ButtonState, onEdited} from './Components'
import { GlobalStateContext } from '../GlobalState';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';

import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';

import {arrayMoveImmutable} from 'array-move';
import {SortableContainer, SortableElement, sortableHandle } from 'react-sortable-hoc';
import logger from '../../utils/logger';



const DragHandle = sortableHandle(() =>  
<span className="drag-handle">
<i className="dragicon"><img src="/images/dragbtn.png" alt="..." /></i>
</span>
);



const SortableItem = SortableElement(({value, text_en, text_ru, name, id, content, content_en, content_ru, img, html, html_en, html_ru, handleInputChange, handleTextChange, handleTextEnChange, handleTextRuChange, handleContentChange, handleContentChangeEn, handleContentChangeRu, handleImgChange, handleHtmlChange, handleHtmlEnChange, handleHtmlRuChange, remove, language, displayMode }) => 
  {
    const {_id} = useSelector(User.get());
    
    const [isDraggable, setIsDraggable] = useState(true);
    const editorContainerRef = useRef(null);

    useEffect(() => {
      const stopPropagationForToolbar = () => {
        if (editorContainerRef.current) {
          const toolbar = editorContainerRef.current.querySelector('.ck-toolbar');
          if (toolbar) {
            toolbar.querySelectorAll('button').forEach((button) => {
              button.addEventListener('mousedown', (event) => {
                event.stopPropagation();
              });
            });
          }
        }
      };
      stopPropagationForToolbar();
    }, []);

  
  return (
  <div>
    <div className="double-input mb-3 sortable-item">    
      <DragHandle />
      <div className='inputs'>
          
        {/* Language-aware name input - show only active language */}
        {language === 'default' && (
          <input
            key={id+'-et'}
            name={name}
            className="form-control top"
            placeholder="name (et)"
            defaultValue={name}
            type="text"
            onChange={onEdited}
            onBlur={handleTextChange}
          />
        )}

        {language === 'en' && (
          <input
            key={id+'-en'}
            name={text_en}
            className="form-control top"
            placeholder="name (en)"
            defaultValue={text_en}
            type="text"
            onChange={onEdited}
            onBlur={handleTextEnChange}
          />
        )}

        {language === 'ru' && (
          <input
            key={id+'-ru'}
            name={text_ru}
            className="form-control top"
            placeholder="name (ru)"
            defaultValue={text_ru}
            type="text"
            onChange={onEdited}
            onBlur={handleTextRuChange}
          />
        )}

        {/* Value - always shown */}
        <input
          id={id}
          name={value}
          className="form-control bottom"
          placeholder="value"
          type="text"
          defaultValue={value}
          onChange={onEdited}
          onBlur={handleInputChange}
        />

        {/* Mode-specific fields */}
        {displayMode === 'choices' && (
          <>
            <input
              id={id}
              name={img}
              className="form-control bottom"
              placeholder="img url"
              type="text"
              defaultValue={img}
              onChange={onEdited}
              onBlur={handleImgChange}
            />

            {language === 'en' && content_en !== undefined && (
              <div>
                <div id="content" ref={editorContainerRef}>
                  <CKEditor
                    onReady={(editor_en) => {}}
                    config={{
                      toolbar: ['bold', 'italic', 'link'],
                      link: {
                        addTargetToExternalLinks: true,
                      },
                      simpleUpload: {
                        uploadUrl: `${process.env.REACT_APP_BASE_URL}/chat/image/${_id}`,
                      }
                    }}
                    onChange={onEdited}
                    editor={ClassicEditor}
                    data={content_en}
                    onBlur={(e, editor_en) => {
                      const editorcontent = editor_en.getData()
                      handleContentChangeEn(editorcontent);
                    }}
                  />
                </div>
              </div>
            )}

            {language === 'ru' && content_ru !== undefined && (
              <div>
                <div id="content" ref={editorContainerRef}>
                  <CKEditor
                    onReady={(editor_ru) => {}}
                    config={{
                      toolbar: ['bold', 'italic', 'link'],
                      link: {
                        addTargetToExternalLinks: true,
                      },
                      simpleUpload: {
                        uploadUrl: `${process.env.REACT_APP_BASE_URL}/chat/image/${_id}`,
                      }
                    }}
                    onChange={onEdited}
                    editor={ClassicEditor}
                    data={content_ru}
                    onBlur={(e, editor_ru) => {
                      const editorcontent = editor_ru.getData()
                      handleContentChangeRu(editorcontent);
                    }}
                  />
                </div>
              </div>
            )}

            {(language === 'default' || language === undefined) && (
              <div>
                <div id="content" ref={editorContainerRef}>
                  <CKEditor
                    onReady={(editor) => {}}
                    config={{
                      toolbar: ['bold', 'italic', 'link'],
                      link: {
                        addTargetToExternalLinks: true,
                      },
                      simpleUpload: {
                        uploadUrl: `${process.env.REACT_APP_BASE_URL}/chat/image/${_id}`,
                      }
                    }}
                    onChange={onEdited}
                    editor={ClassicEditor}
                    data={content}
                    onBlur={(e, editor) => {
                      const editorcontent = editor.getData()
                      handleContentChange(editorcontent);
                    }}
                    onFocus={() => setIsDraggable(false)}
                  />
                </div>
              </div>
            )}
          </>
        )}

        {displayMode === 'html' && language === 'default' && (
          <textarea
            key={id+'-html'}
            className="form-control bottom"
            placeholder="HTML content (et)"
            defaultValue={html}
            rows="6"
            onChange={onEdited}
            onBlur={handleHtmlChange}
          />
        )}

        {displayMode === 'html' && language === 'en' && (
          <textarea
            key={id+'-html_en'}
            className="form-control bottom"
            placeholder="HTML content (en)"
            defaultValue={html_en}
            rows="6"
            onChange={onEdited}
            onBlur={handleHtmlEnChange}
          />
        )}

        {displayMode === 'html' && language === 'ru' && (
          <textarea
            key={id+'-html_ru'}
            className="form-control bottom"
            placeholder="HTML content (ru)"
            defaultValue={html_ru}
            rows="6"
            onChange={onEdited}
            onBlur={handleHtmlRuChange}
          />
        )}
      </div>
        
      <button onClick={remove} className="fa fa-trash-alt icon red"></button>
    </div>
  </div>
)});


const SortableList = SortableContainer(({ items, handleContentChange, handleChange, remove, language, displayMode }) => (
  <ul className="sortablelist">
    {Object.keys(items).map((key, i) => (
      <SortableItem
        id={items[key].id}
        next={items[key].next}
        key={key}
        index={i}
        name={items[key].text}
        value={items[key].value}
        text_en={items[key].text_en}
        text_ru={items[key].text_ru}
        content={items[key].content}
        content_en={items[key].content_en}
        content_ru={items[key].content_ru}
        img={items[key].img}
        html={items[key].html}
        html_en={items[key].html_en}
        html_ru={items[key].html_ru}
        language={language}
        displayMode={displayMode}
        handleImgChange={(e) => handleChange(e, i, 'img')}
        handleTextChange={(e) => handleChange(e, i, 'text')}
        handleInputChange={(e) => handleChange(e, i, 'value')}
        handleTextEnChange={(e) => handleChange(e, i, 'text_en')}
        handleTextRuChange={(e) => handleChange(e, i, 'text_ru')}
        handleHtmlChange={(e) => handleChange(e, i, 'html')}
        handleHtmlEnChange={(e) => handleChange(e, i, 'html_en')}
        handleHtmlRuChange={(e) => handleChange(e, i, 'html_ru')}
        handleContentChange={(editorcontent) => handleContentChange(editorcontent, i, 'content')}
        handleContentChangeEn={(editorcontent) => handleContentChange(editorcontent, i, 'content_en')}
        handleContentChangeRu={(editorcontent) => handleContentChange(editorcontent, i, 'content_ru')}
        remove={(e) => remove(items[key].id)}
      />
    ))}
  </ul>
));


const zoomSelector = (s) => s.transform[2];




export const DecisionBlock = React.memo((node) => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);  
  const {block, start, review, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = {progress};
  const [previewMode, setPreviewMode] = useState(globalState.preview ? undefined : false);

  useEffect(() => {
    setPreviewMode(globalState.preview);
  }, [globalState.preview]);

  if (!block) {
    return null;
  }
  const {
    data,
    data: {decisions = {}},
  } = block;

  return (
    <>
      {!previewMode &&(
        <NodeComponent bot={bot} block={block} name="Decision" icon="decision" data={data} node={node} start={start} routes={decisions} />
      )}
      {previewMode && (
        <PreviewComponent bot={bot} data={data} node={node} start={start} decisions={decisions}/>
      )}
    </>
  );
});

export const DecisionEditor = ({nodeid, block, data, decisions, language}) => {

  const refTxtText = useRef(null);
  const refTxtValue = useRef(null);

  const [deci, setDeci] = useState(decisions)

  useEffect(() => {
    setDeci(decisions)
  }, [decisions]);

  useEffect(() => {
    logger.log("UUs keel ", language)
  }, [language]);

  if (!block) {
    return null;
  }

  const handleSortEnd = ({node, oldIndex, newIndex }) => {
    logger.log(decisions, deci)
    const deciArray = Object.values(deci);
    const newItems = arrayMoveImmutable(deciArray, oldIndex, newIndex);
    const updateItems = newItems.map((item, index) => {
      return { ...item };
    });
    const updatedDeci = updateItems.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    setDeci(updatedDeci);
    const data = {
      decisions: updatedDeci
    };
    Chatbot.setBlockData(nodeid, data);
  };

  const handleChange = async (e, index, label) => {
    const deciArray = Object.values(deci);
    deciArray[index] = {
      id: deciArray[index].id,
      [label]: e.target.value,
    }
    const updatedDeci = deciArray.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    setDeci(updatedDeci);
    const data = {
      decisions: updatedDeci
    };
    Chatbot.setBlockData(nodeid, data);
  };

  const handleContentChange = async (editorcontent, index, label) => {
    logger.log("SAVE:" , label)
    const deciArray = Object.values(deci);
    deciArray[index] = {
      id: deciArray[index].id,
      [label]:  editorcontent,
    }
    const updatedDeci = deciArray.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    setDeci(updatedDeci);
    const data = {
      decisions: updatedDeci
    };
    Chatbot.setBlockData(nodeid, data);
  };

  const handleContentChangeEn = async (editorcontent, index, label) => {
    const deciArray = Object.values(deci);
    deciArray[index] = {
      id: deciArray[index].id,
      [label]:  editorcontent,
    }
    const updatedDeci = deciArray.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    setDeci(updatedDeci);
    const data = {
      decisions: updatedDeci
    };
    Chatbot.setBlockData(nodeid, data);
  };

  const addDecisionField = (e) => {
    logger.log(decisions)
    e.preventDefault();
    const id = Date.now().toString();
    const text = refTxtText.current.value;
    const value = refTxtValue.current.value;
    const text_en = '';
    const text_ru = '';
    const content = '';
    const content_en = '';
    const content_ru = '';
    const img = "";
    const html = "";
    const html_en = "";
    const html_ru = "";
    
    if (text !== '') {
      Chatbot.setBlockData(nodeid, {decisions: {[id]: {id, text, text_en, text_ru, value, content, content_en, content_ru, img, html, html_en, html_ru}}});
      refTxtText.current.value = '';
      refTxtValue.current.value = '';
      onEdited('added');
    }
  };

  const removeDecisionField = async (id) => {
    Chatbot.removeBlockDecision(nodeid, id);
    onEdited();
  };

  const onSortStart = ({ node }) => {
    logger.log(node)
  };

  const displayMode = data.displayMode || (data.isChoices ? 'choices' : 'buttons');

  return (
    <>
    
    <div className="section">DISPLAY MODE</div>
    <div className="mode-selector" style={{display: 'flex', gap: '8px', marginBottom: '10px'}}>
      {['buttons','choices','html'].map(mode => (
        <span key={mode}
          className={`mode-pill ${displayMode === mode ? 'active' : ''}`}
          style={{
            padding: '6px 12px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            backgroundColor: displayMode === mode ? '#032097' : '#f0f0f0',
            color: displayMode === mode ? 'white' : '#000',
            fontSize: '12px',
            fontWeight: 'bold'
          }}
          onClick={() => { Chatbot.setBlockData(block.id, {displayMode: mode}); onEdited(); }}
        >{mode}</span>
      ))}
    </div>

    <div className='section' style={{marginTop: '20px'}}>ROUTES</div>

    <div className='double-input mb-3'>

        <div className='inputs'>
     
        <input
            type="input"
            id="txtText"
            className="form-control top"
            placeholder="Text"
            ref={refTxtText}
            onKeyPress={(e) => (e.key === 'Enter' ? addDecisionField(e) : e)}
          />

          <input
            type="input"
            id="txtValue"
            className="form-control bottom"
            placeholder="value"
            ref={refTxtValue}
            onKeyPress={(e) => (e.key === 'Enter' ? addDecisionField(e) : e)}
          />

        </div>

        <span className="icon" onClick={(e) => addDecisionField(e)}>
        <i className="fa fa-plus"></i>
      </span>
    </div>

    <SortableList items={deci} onSortEnd={handleSortEnd} helperClass="sortable" onSortStart={onSortStart} handleChange={handleChange} handleContentChange={handleContentChange} remove={removeDecisionField} language={language} displayMode={displayMode}/>

    <ButtonState block={block} data={data} dataname="isDateTime" label="Record date and time"/>

    </>
  )
}
